import { defineStore } from "pinia";
import { ref } from "vue";

export const useEditableElementStore = defineStore("editableElement", () => {
    const selectedElement = ref({
        fieldName: null,
        blockId: null,
    });

    function selectElement(selection) {
        selectedElement.value = selection;
    }

    function clearSelection() {
        selectedElement.value = null;
    }

    return {
        selectedElement,
        selectElement,
        clearSelection,
    };
});
